//TODO: ErrorBoundary for PointsForDrawingsSection
//TODO: Refactor PointsForDrawingsSection and move to sg-ui-components

import React from 'react';
import { connect } from 'react-redux';
import { CurrentSweepstakes, CurrentPromotions, DisplayContent, ErrorBoundary, getConfigForComponent } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import PointsForDrawingsSection from '../Components/PointsForDrawings/PointsForDrawings';
import promotionConfig from '../promotionConfig';

const Promotions = ({ user, config, sweep, promotion, cmsSourceFirebase, actions, match, pointsForDrawings }) => {
    const promotionsCurrentSweepstakes = getConfigForComponent('promotionsCurrentSweepstakes', config);
    const promotionsPointsForDrawings = getConfigForComponent('pointsForDrawings', config);
    const promotionsCurrentPromotions = getConfigForComponent('promotionsCurrentPromotions', config);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <DisplayContent
                note='Show Promotions page Current Sweepstakes / Second-Chance Promotions section'
                isVisible={promotionsCurrentSweepstakes?.enabled}>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <section id={promotionsCurrentSweepstakes?.hash}>
                            <ErrorBoundary fallback={promotionsCurrentSweepstakes?.errorBoundaryFallback} details={{ user, config }}>
                                <CurrentSweepstakes
                                    {...{ sweep, cmsSourceFirebase, actions }}
                                    telescript={promotionsCurrentSweepstakes?.telescript}
                                    mode={promotionsCurrentSweepstakes?.config?.mode ?? 'all-current-promotions'}
                                    options={
                                        promotionsCurrentSweepstakes?.config ?? {
                                            hasCollapser: false,
                                            variant: 'theme-primary',
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </section>
                    </div>
                </div>
            </DisplayContent>

            <DisplayContent note='Show Points For Drawings / Redeem Coin section' isVisible={promotionsPointsForDrawings?.enabled}>
                <section id={promotionsPointsForDrawings?.hash}>
                    <ErrorBoundary fallback={promotionsPointsForDrawings?.errorBoundaryFallback} details={{ user, config }}>
                        <PointsForDrawingsSection {...{ actions, pointsForDrawings }} />
                    </ErrorBoundary>
                </section>
            </DisplayContent>

            <DisplayContent note='Show Promotions page Current Promotions / My Rewards / Achievements section' isVisible={promotionsCurrentPromotions?.enabled}>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <section id={promotionsCurrentPromotions?.hash}>
                            <ErrorBoundary fallback={promotionsCurrentPromotions?.errorBoundaryFallback} details={{ user, config }}>
                                <CurrentPromotions
                                    {...{ user, config, promotion, cmsSourceFirebase, actions }}
                                    telescript={promotionsCurrentPromotions?.telescript}
                                    mode={promotionsCurrentPromotions?.config?.mode ?? 'show-limited'}
                                    options={
                                        promotionsCurrentPromotions?.config ?? {
                                            hasCollapser: false,
                                            variant: 'theme-primary',
                                            jurisdiction: promotionConfig?.jurisdiction,
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </section>
                    </div>
                </div>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Promotions);
